import React from "react";
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
} from "@vis.gl/react-google-maps";

import { resolveRouteColorPalette } from "../routeColor";
import { intervalToDuration } from "date-fns";

export const calculateCrewStatus = (createdAt) => {
  let duration = null;
  let crewStatus = !createdAt ? "inactive" : "active";

  if (crewStatus === "active") {
    duration = intervalToDuration({
      start: new Date(),
      end: new Date(createdAt),
    });
    if (duration.days >= 1 || duration.hours >= 1 || duration.minutes >= 30) {
      crewStatus = "out-of-contact";
    }
  }
  return [crewStatus, duration];
};

export const CrewPin = ({ position, color, status, onClick, initials }) => {
  const crewActive = status === "active";

  const markerClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <AdvancedMarker
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      onClick={markerClick}
      position={position}
    >
      <span
        className={`relative z-10 flex size-9 items-center justify-center rounded-full ${resolveRouteColorPalette(color).bg} border-2`}
      >
        <InternalCrewIcon active={crewActive} initials={initials} />
      </span>
    </AdvancedMarker>
  );
};

export const CrewIcon = ({ color, enabled, initials }) => {
  return (
    <span
      className={`inline-flex size-5 items-center justify-center rounded-full ${resolveRouteColorPalette(color).bg}`}
    >
      <InternalCrewIcon active={enabled} isSmall={true} initials={initials} />
    </span>
  );
};

const InternalCrewIcon = ({ active, isSmall, initials }) => {
  const size = isSmall ? "size-5" : "size-8";
  return active ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg4"
      version="1.1"
      stroke="white"
      strokeWidth="1.5"
      viewBox="0 0 24 24"
      fill="none"
    >
      <defs id="defs8" />
      <text
        id="text821"
        y="15.397282"
        x="4.900157"
        style={{
          fontStyle: "normal",
          fontVariant: "normal",
          fontWeight: "normal",
          fontStretch: "normal",
          fontSize: "11.47177792px",
          lineHeight: 1.25,
          fontFamily: "Legacy Sans ITC Book",
          letterSpacing: "0px",
          wordSpacing: "0px",
          fill: "#ffffff",
          fillOpacity: 1,
          stroke: "none",
          strokeWidth: 0.47799075,
        }}
      >
        <tspan
          style={{
            fontStyle: "normal",
            fontVariant: "normal",
            fontWeight: "bold",
            fontStretch: "normal",
            fontFamily: "Courier New",
            fill: "#ffffff",
            strokeWidth: 0.47799075,
          }}
          y="15.397282"
          x="4.900157"
          id="tspan819"
        >
          {initials}
        </tspan>
      </text>
      {/* <path
      id="path823"
      d="M 12,2.542969 A 9.4576273,9.4576273 0 0 0 2.542969,12 9.4576273,9.4576273 0 0 0 12,21.457031 9.4576273,9.4576273 0 0 0 21.457031,12 9.4576273,9.4576273 0 0 0 12,2.542969 Z m 0,1.1171874 A 8.3389835,8.3389835 0 0 1 20.339844,12 8.3389835,8.3389835 0 0 1 12,20.339844 8.3389835,8.3389835 0 0 1 3.660156,12 8.3389835,8.3389835 0 0 1 12,3.6601564 Z"
      style={{opacity:1,fill:'#ffffff',fillOpacity:1,stroke:'none',strokeWidth:46.99499893,strokeMiterlimit:4,strokeDasharray:'none',strokeOpacity:1}}
    /> */}
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="white"
      className={size}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z"
      />
    </svg>
  );
};
